import { render, staticRenderFns } from "./dataDictionary.vue?vue&type=template&id=445c4616&scoped=true&"
import script from "./dataDictionary.vue?vue&type=script&lang=js&"
export * from "./dataDictionary.vue?vue&type=script&lang=js&"
import style0 from "./dataDictionary.vue?vue&type=style&index=0&id=445c4616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c4616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445c4616')) {
      api.createRecord('445c4616', component.options)
    } else {
      api.reload('445c4616', component.options)
    }
    module.hot.accept("./dataDictionary.vue?vue&type=template&id=445c4616&scoped=true&", function () {
      api.rerender('445c4616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dataDictionary.vue"
export default component.exports